import { Link } from "react-router-dom";
import { useLang } from "../i18n";

export function QuoteLink({ children, className = "", testid }) {
  const { prefix } = useLang();
  return (
    <Link to={`${prefix}/enquiry`} className={className} data-testid={testid}>
      {children}
    </Link>
  );
}
